import { Injectable, inject } from '@angular/core';
import {Observable, zip} from 'rxjs';
import {map} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../environments/environment';
import {MaandJaar} from '../core/date/maand-jaar';
import {DienstService} from '../dienst/dienst.service';
import {ActiviteitCijfer, ExtendedActiviteitCijferDto, ExtendedActiviteitCijfer} from './activiteit-cijfer';
import {Diensten} from '../dienst/diensten';
import * as lodash from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class ActiviteitCijfersService {
  private http = inject(HttpClient);
  private dienstService = inject(DienstService);

  downloadActiviteitCijfers$(maandJaar: MaandJaar): Observable<Array<ActiviteitCijfer>> {
    return zip(
      this.dienstService.getDiensten$(),
      this.getActiviteitCijfers(maandJaar)
    )
      .pipe(
        map(([diensten, extendedActiviteitCijfers]: [Diensten, Array<ExtendedActiviteitCijfer>]) =>
          extendedActiviteitCijfers.map(extendedActiviteitCijfer =>
            extendedActiviteitCijfer.toActiviteitCijfer(diensten.getDienst(extendedActiviteitCijfer.getDienstId())))
        ),
        map(activiteitCijfers => lodash.sortBy(activiteitCijfers, ['medewerkernummer']))
      );
  }

  private getActiviteitCijfers(maandJaar: MaandJaar): Observable<Array<ExtendedActiviteitCijfer>> {
    return this.http.post<Array<ExtendedActiviteitCijferDto>>(`${environment.apiUrl}/export/activiteit/cijfers`, maandJaar)
      .pipe(map(activiteitCijferDtos => activiteitCijferDtos.map(dto => ExtendedActiviteitCijfer.deserialize(dto))
      ));
  }
}
